<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> REPORTE </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="obtenerUrl()"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      url: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerReporte", item => {
      //this.tipo_documento = this.obtenerTipo(item)
      this.form = item;
      this.url = this.obtenerUrl();
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    obtenerUrl() {
      try {
        let url;
        let user = this.$storage.get("user");
        let nombre_reporte = "";
        let formato_doc = "output=pdf";
        let nombre_carpeta;
           nombre_carpeta="vacaciones"
        
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
        if (this.form.reprogramacion == 0) {
          nombre_reporte = "rpt_vacacion_programada";
        }
         if (this.form.reprogramacion == 1) {
          nombre_reporte = "rpt_vacacion_reprogramada_uso";
        }
         if (this.form.reprogramacion == 2) {
          
          nombre_reporte = "rpt_vacacion_reprogramada";
        }
         if (this.form.reprogramacion == 4) {
          
          nombre_reporte = "";
        }
        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
         let url_parametros
        //Parametros
        let id_programacion = this.form.id;
        // URL con parametros reprogramadas 
           if (this.form.reprogramacion ==2) {
          url_parametros = `${url}&p_id_programada=${parseInt(this.form.id_vacacion_programada)}`;
        }
        // URL con parametros uso vacacion prog 
          if (this.form.reprogramacion ==0 || this.form.reprogramacion==1) {
         // url_parametros = `${url}&p_id_programada=${this.form.id_vacacion_programada}&p_usuario_sesion=${user.usuario}`;
         url_parametros = `${url}&p_gestion=${this.form.gestion}&p_correlativo=${this.form.correlativo}&p_usuario_sesion=${user.usuario}`;
        }
       
        if (this.form.reprogramacion == 3) {
          url_parametros = `${url}&id_persona=${this.form.id_persona}&usuario=${user.usuario}`;
        }
        console.log(url_parametros)
        return url_parametros;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/VerReporte.vue